module.exports = __webpack_public_path__ + "static/2-0de73058378678bdce01ac57741bf3b0.png";